import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionIntro } from './components/SolutionIntro';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { UrgencyTimer } from './components/UrgencyTimer';
import { PricingSection } from './components/PricingSection';
import { ExpertComparison } from './components/ExpertComparison';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-amber-500/30" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <SolutionIntro data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <UrgencyTimer data-id="element-6" />
      <PricingSection data-id="element-7" />
      <ExpertComparison data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <CostComparison data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}